import * as React from 'react'

import { observer } from 'mobx-react'

import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'

import StatsRow from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/StatsRow'
import allowanceIncidences from 'modules/timeoff/store/collections/allowanceIncidences'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

import TotalTooltip from './TotalTooltip'
import { computeTotalAmount } from './totalAmount'

interface Props {
  allowance: Allowance
  selectedStat: AllowanceStat
  selectedCycle: Cycle
}

const TotalDays = ({ allowance, selectedStat, selectedCycle }: Props) => {
  const { has_dev_timeoff_new_totalcalculations: useNewTotalCalculations } = useFeatures([
    'dev_timeoff_new_totalcalculations',
  ])

  const {
    prorated_allowance_days: proratedDays,
    carry_overs: carryOvers,
    incidences: totalAdjustment,
    accumulated_carry_over: totalCarryover,
    total,
  } = selectedStat.attributes

  const incidences = allowanceIncidences.filter(
    (incidence) =>
      incidence.attributes.timeoff_allowance_id === allowance.id &&
      incidence.attributes.year === selectedCycle.end.year()
  )

  const displayedTotal = computeTotalAmount({
    useNewTotalCalculations,
    total,
    proratedDays,
    totalAdjustment,
    totalCarryover,
  })

  const title = allowance.isDays
    ? i18n.t('time_off.new_counter.total_row.days')
    : i18n.t('time_off.new_counter.total_row.hours')

  return (
    <StatsRow
      title={title}
      amount={displayedTotal}
      tooltip={
        <TotalTooltip
          accrued={proratedDays}
          allowance={allowance}
          carryOvers={carryOvers}
          incidences={incidences}
          stat={selectedStat}
          thisCycle={selectedCycle.yearLabel}
        />
      }
    />
  )
}

export default observer(TotalDays)
